import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface ActiveAcademic {
  id: number;
  academic: string;
  isActive: string;
}

export const activeAcademicApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllActiveAcademics: builder.query<ActiveAcademic[], void>({
      query: () => ({
        url: "academic/active-academics",
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<ActiveAcademic[]>) => res.results ?? [],
      providesTags: [{ type: "Academic", id: "ACTIVE_LIST" }],
    }),
  }),
});

export const { useGetAllActiveAcademicsQuery } = activeAcademicApiSlice;
